import React from 'react';
import DocumentList from 'components/fields/DocumentList';
import { CandidateStories } from 'types/candidateStories';
import { SearchRecord } from 'types/record';
import { stripEmojis } from '../../../../../../../../../lib/helpers';
import { CandidateStoryItemTitle } from '../../../Common';

type Props = {
  candidateStories: CandidateStories;
  record?: SearchRecord;
  type: string; // can be 'general' or record resource id
};

const CandidateStorySummaryItem = ({
  candidateStories,
  record,
  type,
}: Props) => {
  const content = candidateStories.content?.[type] || '';
  const documents = candidateStories[type].documents || [];

  return (
    <div
      className='cans-item-wrapper'
      data-testid='candidate-story-summary-item'
    >
      <div className='form-question'>
        <CandidateStoryItemTitle record={record} />
      </div>
      <span>{stripEmojis(content)}</span>
      <div className='cans-doc-wrapper'>
        <DocumentList documents={documents} allowDocumentRemoval={false} />
      </div>
    </div>
  );
};

export default CandidateStorySummaryItem;
